<template>
  <v-row justify="center">
    <v-dialog
        v-model="dialog"
        max-width="70%"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5 align-center">Plano (Coberturas)</span>
          <v-col class="d-flex flex-row justify-end">
            <v-btn small @click="loadData">
              <v-icon small title="Buscar">fas fa-search</v-icon>
            </v-btn>
            <v-btn small @click="add" v-show="items && items.length">
              <v-icon small title="Adicionar">fas fa-plus</v-icon>
            </v-btn>
            <v-btn small @click="hide">
              <v-icon small title="Fechar">fas fa-window-close</v-icon>
            </v-btn>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="dialogForm">
              <v-row>
                <v-col cols="5">
                  <v-text-field
                    dense
                    label="Código"
                    v-model="product.productCode"
                    outlined
                  />
                </v-col>
                <v-col cols="7">
                  <v-text-field
                    dense
                    label="Descrição"
                    v-model="product.description"
                    outlined
                  />
                </v-col>
                <v-col cols="6">
                  <v-select
                    dense
                    outlined
                    v-model="product.carrierId"
                    :items="carriers"
                    item-text="name"
                    item-value="id"
                    label="Operadora"
                    :clearable="true"
                    :loading="this.carriers.length == 0"
                  />
                </v-col>
                <v-col cols="6">
                  <v-select
                    dense
                    outlined
                    v-model="product.productFamilyId"
                    :items="productFamilies"
                    item-text="name"
                    item-value="id"
                    label="Produto Operadora"
                    :clearable="true"
                    :loading="this.productFamilies.length == 0"
                  />
                </v-col>
                <v-col cols="12">
                  <v-select
                    dense
                    outlined
                    v-model="product.benefitId"
                    :items="benefits"
                    item-text="name"
                    item-value="id"
                    label="Benefício"
                    :clearable="true"
                    :loading="this.benefits.length == 0"
                  />
                </v-col>
              </v-row>
            </v-form>
            <v-data-table
              v-if="items"
              v-model="selected"
              :headers="headers"
              :items="items"
              :loading="isSearching"
              item-key="id"
              locale="pt-BR"
              show-select
              class="elevation-1 mt-2"
            >
              <template v-slot:item.isActive="{ item }">
                {{ item.isActive ? 'Sim' : 'Não' }}
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Product2Service from "@/services/odoo/ProductService"
import BenefitService from "@/services/odoo/BenefitService";
import CarrierService from "@/services/odoo/CarrierService";
import ProductFamilyService from "@/services/odoo/ProductFamilyService";

let initialData = {
  selected: [],
  items: null,
  totalElements: 0,
}

export default {
  props: {
    coverageId: {
      type: String
    },
  },
  data() {
    return {
      dialog: false,
      product: {},
      benefits: [],
      carriers: [],
      productFamilies: [],
      options: {},
      headers: [
        { text: 'Código', align: 'left', value: 'code'},
        { text: 'Descrição', align: 'left', value: 'description'},
        { text: 'Ativo', align: 'end', value: 'isActive'}
      ],
      isSearching: false,
      singleSelect: false,
      ...initialData
    };
  },
  async created() {
    this._product2Service = new Product2Service();
    this._benefitService = new BenefitService();
    this._carrierService = new CarrierService();
    this._productFamilyService = new ProductFamilyService();
  },
  watch: {
    options: {
      handler() {
        this.loadData()
      },
      deep: true,
    },
  },
  methods: {
    resetData() {
      if (this.$refs.dialogForm)
        this.$refs.dialogForm.reset();
      
      for (const prop in initialData) {
        this[prop] = initialData[prop];
      }
    },
    async loadData() {
      this.isSearching = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const { data } = await this._product2Service.findAllByParams(
        Object.assign(
          this.product,
          {
            page: page ? page - 1 : 0,
            sortBy: sortBy && sortBy.length? sortBy[0] : 'cnpj',
            descending: sortDesc && sortDesc.length? sortDesc[0] : false,
            size: itemsPerPage
          }
        )
      );
      this.items = data.content;
      this.totalElements = data.totalSize;
      this.isSearching = false;
      this.$emit('on-load')
    },
    show() {
      this.resetData();
      this.dialog = true
      if (this.benefits.length || this.carriers.length || this.productFamilies.length) return;
      this._benefitService.findAll().then((res) => this.benefits = res.data.records);
      this._carrierService.findAllCarrier().then((res) => this.carriers = res.data.records);
      this._productFamilyService.findAll().then((res) => this.productFamilies = res.data.records);
    },
    hide() {
      this.dialog = false;
    },
    add() {
      this.$emit('selected', this.selected)
      this.items = [];
      this.hide();
    }
  }
};
</script>
